{
  "orderBook": {
    "title": "Книга ордеров",
    "bid": "Bid",
    "ask": "Ask",
    "bidSell": "Bid (Sell)",
    "askBuy": "Ask (Buy)"
  }
}
